import { makeAddItemsToCart } from '../../core/cart/machine/context/add-items-to-cart';
import { generateGiftboxId } from '../utils/generate-giftbox-id';
import { reloadIfOnCartPage } from '../utils/reload-if-on-cart-page';
import { assignLineToGiftBox, unassignLineFromGiftBox, corePropsMatch } from '../utils/cart-line-operations';
export const saveGiftBoxEdits = async ({ itemKey , state , giftboxProducts , onSuccess , onError , onCartUpdate  })=>{
    var _parent_properties;
    // Always work from the latest cart snapshot
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    onCartUpdate(cart);
    const parent = (cart.items || []).find((it)=>it.key === itemKey);
    if (!parent) {
        onError('Gift box not found in cart');
        return;
    }
    // Ensure we have a stable parent instance id
    let parentId = (_parent_properties = parent.properties) === null || _parent_properties === void 0 ? void 0 : _parent_properties._gift_box_id;
    if (!parentId) parentId = generateGiftboxId();
    // Group desired selections by line key with counts (unit keys: `lineKey::index`)
    const selectedArray = Array.isArray(state.items) ? state.items : [];
    const desiredCountByLineKey = {};
    selectedArray.forEach((unitKey)=>{
        const lineKey = String(unitKey).split('::')[0];
        var _desiredCountByLineKey_lineKey;
        if (lineKey) desiredCountByLineKey[lineKey] = ((_desiredCountByLineKey_lineKey = desiredCountByLineKey[lineKey]) !== null && _desiredCountByLineKey_lineKey !== void 0 ? _desiredCountByLineKey_lineKey : 0) + 1;
    });
    // Resolve the variant: prefer explicit state.variant, then look up first
    // variant from giftboxProducts using state.giftbox (same logic as submit-giftbox),
    // then fall back to the existing parent variant.
    let newVariantId = parent.variant_id;
    const selectedProduct = state.giftbox ? giftboxProducts === null || giftboxProducts === void 0 ? void 0 : giftboxProducts[state.giftbox] : null;
    if (state.variant) {
        newVariantId = Number(state.variant);
    } else if (state.giftbox && (giftboxProducts === null || giftboxProducts === void 0 ? void 0 : giftboxProducts[state.giftbox])) {
        var _prod_variants, _prod_variants_;
        const prod = giftboxProducts[state.giftbox];
        if (prod === null || prod === void 0 ? void 0 : (_prod_variants = prod.variants) === null || _prod_variants === void 0 ? void 0 : (_prod_variants_ = _prod_variants[0]) === null || _prod_variants_ === void 0 ? void 0 : _prod_variants_.id) {
            newVariantId = Number(prod.variants[0].id);
        }
    }
    const variantChanged = newVariantId && Number(newVariantId) !== Number(parent.variant_id);
    if (variantChanged) {
        try {
            var _state_giftboxMessage;
            const parentProps = {
                ...parent.properties || {},
                _gift_box_id: parentId,
                _gift_box_message: (_state_giftboxMessage = state.giftboxMessage) !== null && _state_giftboxMessage !== void 0 ? _state_giftboxMessage : ''
            };
            const addItemsToCart = makeAddItemsToCart();
            await addItemsToCart({
                items: [
                    {
                        id: newVariantId,
                        quantity: parent.quantity || 1,
                        properties: parentProps
                    }
                ]
            });
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: parent.key,
                    quantity: 0
                })
            });
        } catch (err) {
            console.warn('Failed to update giftbox variant', err);
        }
    } else {
        try {
            var _state_giftboxMessage1;
            const parentProps = {
                ...parent.properties || {},
                _gift_box_id: parentId,
                _gift_box_message: (_state_giftboxMessage1 = state.giftboxMessage) !== null && _state_giftboxMessage1 !== void 0 ? _state_giftboxMessage1 : ''
            };
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: parent.key,
                    properties: parentProps
                })
            });
        } catch (err) {
            console.warn('Failed to update parent properties', err);
        }
    }
    // For each cart item that is not the giftbox itself and not an embroidery
    // personalization child: assign or unassign using the shared primitives.
    // This correctly handles partial-quantity splits and sibling merges.
    for (const line of cart.items || []){
        var _line_properties, _line_properties1;
        if (line.key === itemKey) continue;
        if ((_line_properties = line.properties) === null || _line_properties === void 0 ? void 0 : _line_properties._embroidery_parent_id) continue;
        const isCurrentlyAssigned = ((_line_properties1 = line.properties) === null || _line_properties1 === void 0 ? void 0 : _line_properties1._gift_box_parent_id) != null && String(line.properties._gift_box_parent_id) === String(parentId);
        var _desiredCountByLineKey_line_key;
        const desiredCount = (_desiredCountByLineKey_line_key = desiredCountByLineKey[line.key]) !== null && _desiredCountByLineKey_line_key !== void 0 ? _desiredCountByLineKey_line_key : 0;
        if (!isCurrentlyAssigned && desiredCount > 0) {
            // Check if there's already a gifted sibling with the same variant AND
            // the same core properties (same embroidery identity, etc.) in this gift box.
            // We must not confuse an embroidered line with a plain line of the same
            // variant — they are different items and must stay on separate cart lines.
            const giftedSibling = (cart.items || []).find((it)=>{
                var _it_properties, _it_properties1;
                return it.key !== line.key && !((_it_properties = it.properties) === null || _it_properties === void 0 ? void 0 : _it_properties._embroidery_parent_id) && Number(it.variant_id) === Number(line.variant_id) && ((_it_properties1 = it.properties) === null || _it_properties1 === void 0 ? void 0 : _it_properties1._gift_box_parent_id) != null && String(it.properties._gift_box_parent_id) === String(parentId) && corePropsMatch(it.properties || {}, line.properties || {});
            });
            if (giftedSibling) {
                try {
                    // Increase gifted sibling by selectedCount
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: giftedSibling.key,
                            quantity: Number(giftedSibling.quantity) + desiredCount
                        })
                    });
                    // Remove or reduce the incoming line
                    await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            id: line.key,
                            quantity: Number(line.quantity) - desiredCount
                        })
                    });
                } catch (err) {
                    console.warn('Failed to merge into gifted sibling', line.key, err);
                }
            } else {
                try {
                    await assignLineToGiftBox(line, desiredCount, parentId);
                } catch (err) {
                    console.warn('Failed to assign line to gift box', line.key, err);
                }
            }
        } else if (isCurrentlyAssigned && desiredCount === 0) {
            try {
                await unassignLineFromGiftBox(line, cart.items || []);
            } catch (err) {
                console.warn('Failed to unassign line from gift box', line.key, err);
            }
        } else if (isCurrentlyAssigned && desiredCount > 0 && desiredCount < Number(line.quantity)) {
            // Partial deselection: reduce the gifted line and split the remainder
            // back out as a regular (non-gifted) line item.
            const remainder = Number(line.quantity) - desiredCount;
            try {
                await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: line.key,
                        quantity: desiredCount
                    })
                });
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        items: [
                            {
                                id: Number(line.variant_id),
                                quantity: remainder,
                                properties: {
                                    ...line.properties || {},
                                    _gift_box_parent_id: null
                                }
                            }
                        ]
                    })
                });
            } catch (err) {
                console.warn('Failed to partially deselect line from gift box', line.key, err);
            }
        }
    }
    const updatedCart = await (await fetch('/cart.js')).json();
    window.dispatchEvent(new CustomEvent('cart-drawer:update', {
        detail: updatedCart
    }));
    if (reloadIfOnCartPage()) return;
    onSuccess();
};
